import { render } from "./UDPCreate.vue?vue&type=template&id=90104c34&ts=true"
import script from "./UDPCreate.vue?vue&type=script&lang=ts"
export * from "./UDPCreate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__